import "./assets/css/style.css";
import UserSessionContextProvider from "./components/contextProvider/usersession";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./components/pages/home";
import ErrorBoundary from "./components/contextProvider/errorboundary";
import NotFound from "./components/pages/notfound";
// import SCS from "./components/pages/projects/scs";
// import DiscordBot from "./components/pages/projects/discordbot";
// import Protected from "./components/pages/protected";

export default function App() {
  return (
    <ErrorBoundary>
      <UserSessionContextProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/protected" element={<Protected />} /> */}
          {/* <Route path="/projects/scs" element={<SCS />} />
          <Route path="/projects/discordbot" element={<DiscordBot />} /> */}
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" />} />
        </Routes>
      </UserSessionContextProvider>
    </ErrorBoundary>
  );
}
